import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  buttonLink: {
    marginRight: 20,
    marginTop: 40,
    marginBottom: 30,
    textTransform: 'none',
    fontWeight: 'bold',
  },
}))

export default useStyles
